!(function () {
    "use strict";

    //  Searchspring Results

    class SearchspringResults extends HTMLElement {
      constructor() {
        super();

        this.CONFIG = {
          SELECT_WIDTH_PADDING: 70,
          SELECT_MIN_WIDTH: 120,
          MAX_SWATCHES_DISPLAY: 6,
          MAX_SWATCHES_MOBILE: 4
        };

        this._selectors = {
          productGrid: '[data-products-grid] .grid',
          productCard: 'product-card',
          resultsCount: '[data-results-count]',
          pagination: '[js-pagination]',
          nextPage: '[js-next-page]',
          sortTrigger: '[js-sort-trigger]',
          filterForm: '[js-searchspring-filter-form]',
          filterInput: '[js-filter-input]',
          collectionTout: '[js-collection-tout]',
          filterTrigger: '[js-filter-trigger]',
          filterCloseButton: '[js-filter-close-button]',
          filterOverlay: '[js-filter-overlay]',
          filterDrawer: '[js-filter-drawer]',
          clearAll: '[js-clear-all]',
          filterResults: '[js-filter-results]',
          activeFilters: '[js-active-filters]',
          activeFiltersContainer: '[js-active-filters-container]',
          removeActiveFilter: '[js-remove-active-filter]'
        };
      }

      connectedCallback() {
        this.siteId = 'hlq244';
        this.domain = encodeURIComponent(window.location.href);
        this.userId = theme.ssCookies.ssUserId;
        this.sessionId = theme.ssCookies.ssSessionIdNamespace;
        this.pageLoadId = theme.ssCookies.ssPageLoadId;
        this.shopperId = theme.ssCookies.ssShopperId;
        this.viewedProducts = encodeURIComponent(theme.ssCookies.ssViewedProducts);
        this.sectionType = this.dataset.sectionType;
        this.productLimit = this.dataset.productLimit;

        this.storeData = {
          filters: '',
          sort: '',
          currentPage: 1
        }

        this.originalFacetOrder = [];
        this.hasRenderedActiveFilters = false;
        this.activeFiltersUpdateTimeout = null;

        if (this.sectionType == 'collection') {
          this.collectionHandle = this.dataset.collectionHandle;
          this.query = null;
        } else {
          this.query = new URLSearchParams(window.location.search).get("q");
        }

        this._createVueApp();
      }

      _createVueApp() {
        const { createApp, onBeforeMount, onMounted, ref, watch, nextTick } = Vue;

        createApp({
          delimiters: ["${", "}"],
          setup: () => {
            // Core state
            const query = ref(this.query);
            const results = ref({});
            const currentPage = ref(1);
            const loading = ref(false);
            const products = ref([]);
            const pagination = ref([]);
            const facets = ref([]);
            const sort = ref([]);
            const filterSummary = ref([]);
            const rootRoute = window.Shopify.routes.root;
            const sectionId = this.dataset.sectionId;
            const imagesLimit = this.dataset.productImagesLimit;

            // Get pagination object
            const getPagination = (res) => {
              const pagination = res && (res.pagination || res) || {};
              return {
                totalResults: pagination.totalResults,
                begin: pagination.begin,
                end: pagination.end,
                currentPage: pagination.currentPage,
                totalPages: pagination.totalPages,
                previousPage: pagination.previousPage,
                nextPage: pagination.nextPage,
                perPage: this.productLimit,
                defaultPerPage: pagination.defaultPerPage
              };
            };

            // Get filter object
            const getFacet = (res) => {
              const facet = res && (res.facets || res) || [];
              return facet;
            };

            // Get sort object
            const getSort = (res) => {
              const sort = res && (res.sorting || res) || [];
              return sort;
            };

            // Get active filters object
            const getFilterSummary = (res) => {
              const filterSummary = res && (res.filterSummary || res) || [];
              return filterSummary;
            };

            // Go to specific page
            const goToPage = async (page, options = {}) => {
              console.log('goToPage', page)
              const { updateHistory = true, scroll = true } = options;
              if (loading.value) return;
              const totalPages = pagination.value.totalPages;
              if (!page || page < 1 || page > totalPages) return;
              // Get products and pagination
              loading.value = true;
              const res = await this._fetchResults(query.value, page);
              results.value = res;
              products.value = res.results || [];
              currentPage.value = page;
              pagination.value = getPagination(res);
              loading.value = false;
              await nextTick();
              // Set new curernt page, re-render pagination, and update history
              this.storeData.currentPage = page;
              this._renderPagination(pagination.value, goToPage);
              if (updateHistory) this._updateHistory(true, false);
              if (scroll) window.scrollTo(0,0);
            };

            onBeforeMount(async () => {
              this._retainHistory();
              // Get current page
              const urlPage = this._getPageFromUrl && this._getPageFromUrl();
              if (urlPage) {
                currentPage.value = urlPage;
                this.storeData.currentPage = urlPage;
              } else if (this.storeData.currentPage && this.storeData.currentPage !== 1) {
                currentPage.value = this.storeData.currentPage;
              }
              // Get products and pagination response
              loading.value = true;
              const res = await this._fetchResults(query.value, currentPage.value);
              console.log('search res', res)
              results.value = res;
              products.value = res.results || [];
              pagination.value = getPagination(res);
              facets.value = getFacet(res);
              sort.value = getSort(res);
              filterSummary.value = getFilterSummary(res);
              // Store original facet order if not already stored
              if (this.originalFacetOrder.length === 0 && facets.value.length > 0) {
                this.originalFacetOrder = facets.value.map(facet => facet.field);
              }
              loading.value = false;
              await nextTick();
              // Render elements
              this._renderPagination(pagination.value, goToPage);
              this._renderFilters(facets.value);
              this._renderSort(sort.value);
              setTimeout(() => {
                this._syncFormInputsWithFilters();
                this._updateActiveFiltersFromForm();
              }, 50);
              this._updateResultsCount(pagination.value.totalResults);
              this._updateFilterResultsCount(pagination.value.totalResults);
              this._toggleCollectionTouts(this.storeData.filters.length > 0);
              // Adjust sort select width on page load
              setTimeout(() => {
                this._adjustSortSelectWidth();
              }, 100);
            });

            watch(products, async (val) => {
              if (!val || !val.length) return;
              await nextTick();
              
              // Clear cached quick-add modals before reinitializing product cards
              this._clearCachedModals();
              
              // Reinitialize all product-card custom elements
              this.querySelectorAll(this._selectors.productCard).forEach((productCard) => {
                // Reinitialize swatches
                if (typeof productCard._handleSwatches === 'function') {
                  productCard._handleSwatches();
                }
                // Reinitialize quick-add-product if it exists
                const quickAddElement = productCard.querySelector('quick-add-product');
                if (quickAddElement && typeof quickAddElement.connectedCallback === 'function') {
                  quickAddElement.connectedCallback();
                }
              });
              
              // Ensusre elements is rendering properly after DOM updates
              this._renderPagination(pagination.value, goToPage);
              this._updateResultsCount(pagination.value.totalResults);
              this._renderFilters(facets.value);
              this._renderSort(sort.value);
              this._renderActiveFilters(filterSummary.value);
              this._toggleCollectionTouts(this.storeData.filters.length > 0);

              // insert inline banners
              const productGrid = this.querySelector(this._selectors.productGrid);
              if (productGrid && results.value.merchandising.content.inline) {
                const isAlreadyInserted = productGrid.querySelector('.searchspring-inline-banner') ? true : false;
                if (!isAlreadyInserted) {
                  const inlineBanners = results.value.merchandising.content.inline;
                  inlineBanners.forEach((banner) => {
                    const bannerElement = document.createElement('div');
                    bannerElement.classList.add("searchspring-inline-banner"); 
                    bannerElement.innerHTML = banner.value;
                    const index = banner.config.position.index;
                    productGrid.insertBefore(bannerElement, productGrid.children[index]);
                  });
                }
              }
            });

            onMounted(() => {
              // Handle browser navigation
              this._onPopState = (evt) => {
                const statePage = evt && evt.state && evt.state.currentPage;
                const urlPage = this._getPageFromUrl && this._getPageFromUrl();
                const targetPage = statePage || urlPage || 1;
                if (targetPage !== currentPage.value) {
                  goToPage(targetPage, { updateHistory: false, scroll: false });
                }
              };
              window.addEventListener('popstate', this._onPopState);
              // Listen for filter changes
              this._onSearchResultsUpdated = (evt) => {
                const { results: newResults, products: newProducts, pagination: newPagination, facets: newFacets, currentPage: newPage } = evt.detail;
                results.value = newResults;
                products.value = newProducts;
                pagination.value = newPagination;
                facets.value = newFacets;
                filterSummary.value = getFilterSummary(newResults);
                currentPage.value = newPage;
                this._renderPagination(newPagination, goToPage);
                this._renderFilters(newFacets);
                this._renderSort(getSort(newResults));
                this._renderActiveFilters(filterSummary.value);
                this._updateResultsCount(newPagination.totalResults);
                this._updateFilterResultsCount(newPagination.totalResults);
              };
              // Init listerners
              this.addEventListener('searchResultsUpdated', this._onSearchResultsUpdated);
              this._initFilterDrawer();
            });

            // Utils
            const formatPrice = (price) => {          
              return window.theme.formatMoney(price, theme.moneyFormat);
            };

            const handleizeString = (str) => {
              return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
            }

            const swatches = (product) => {
              const swatchTags = product.tags.filter((tag) => tag.startsWith('product-group-'));

              if (swatchTags.length == 0) return ''

              let swatchesMarkup = `<div class="product-card__swatches-container hidden"
                                      data-handle="${product.handle}"
                                      data-tag="${swatchTags[0]}"
                                      js-related-colors>
                                      <div class="product-card__swatches-wrapper">
                                      </div>
                                    </div>`;
              return swatchesMarkup
            }

            const intelliSuggestClickTracking = (e, d, s) => {
              const el = e.currentTarget;
              if (IntelliSuggest && typeof IntelliSuggest.clickItem === 'function') {
                try {
                  IntelliSuggest.clickItem(el, {
                    siteId: this.siteId,
                    intellisuggestData: d,
                    intellisuggestSignature: s
                  });
                } catch (err) {
                  console.warn('[SS] clickItem error', err);
                }
              }
            }

            const didYouMeanOnClick = (term) => {
              const searchForm = this.querySelector('#SearchForm');
              const searchFormInput = searchForm.querySelector('[type="search"]');
              searchFormInput.value = term;
              searchForm.submit();
            }

            return {
              results,
              products,
              currentPage,
              loading,
              rootRoute,
              sectionId,
              formatPrice,
              swatches,
              imagesLimit,
              intelliSuggestClickTracking,
              didYouMeanOnClick
            };
          },
        }).mount(this);
        
        // Clean up listener when element is removed
        this.addEventListener('disconnect', () => {
          if (this._onPopState) window.removeEventListener('popstate', this._onPopState);
        });
      }

      _initFilterDrawer() {        
        if (!this._eventDelegationAdded) {
          this._setupEventDelegation();
          this._eventDelegationAdded = true;
        }
        this._cacheFilterElements();
      }

      _setupEventDelegation() {
        const eventHandlers = [
          { selector: this._selectors.filterTrigger, handler: () => this.openFilterDrawer() },
          { selector: this._selectors.filterCloseButton, handler: () => this.closeFilterDrawer() },
          { selector: this._selectors.filterOverlay, handler: () => this.closeFilterDrawer() },
          { selector: this._selectors.clearAll, handler: () => this._clearFilterSort() }
        ];

        eventHandlers.forEach(({ selector, handler }) => {
          this.addEventListener('click', (e) => {
            if (e.target.closest(selector)) {
              e.preventDefault();
              handler();
            }
          });
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeFilterDrawer();
          }
        });
      }

      _cacheFilterElements() {
        this.filterButton = this.querySelector(this._selectors.filterTrigger);
        this.filterCloseButtons = this.querySelectorAll(this._selectors.filterCloseButton);
        this.filterOverlay = this.querySelector(this._selectors.filterOverlay);
        this.filterDrawer = this.querySelector(this._selectors.filterDrawer);
        this.clearAllButton = this.querySelector(this._selectors.clearAll);
      }

      openFilterDrawer() {
        if (this.filterDrawer && this.filterOverlay) {
          this.filterDrawer.classList.add('is-open');
          this.filterOverlay.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      }

      closeFilterDrawer() {
        if (this.filterDrawer && this.filterOverlay) {
          this.filterDrawer.classList.add('is-closing');
          this.filterOverlay.classList.remove('open');
          setTimeout(() => {
            this.filterDrawer.classList.remove('is-open', 'is-closing');
            document.body.style.overflow = '';
          }, 600);
        }
      }

      _getPageFromUrl() {
        try {
          const params = new URLSearchParams(window.location.search);
          const pageParam = params.get('page');
          if (!pageParam) return null;
          const pageNum = parseInt(pageParam, 10);
          return isNaN(pageNum) ? null : pageNum;
        } catch (e) {
          return null;
        }
      }

      _retainHistory() {
        const urlParams = new URLSearchParams(window.location.search);
        let filterParams = '';
        
        for (const [key, value] of urlParams.entries()) {
          if (key.startsWith('filter.')) {
            filterParams += `&${key}=${value}`;
          }
        }
        
        // Set filters from URL if found
        if (filterParams) {
          this.storeData.filters = filterParams;
        }
        
        // Get and set sort parameter
        const sortParam = urlParams.get('sort_by');
        if (sortParam) {
          this.storeData.sort = `&sort_by=${sortParam}`;
        }
        
        // Get and set page parameter
        const pageParam = urlParams.get('page');
        if (pageParam) {
          this.storeData.currentPage = parseInt(pageParam, 10);
        }

        // Also check history.state for additional state (for browser navigation)
        if (history.state) {
          if (history.state.filters) {
            this.storeData.filters = history.state.filters;
          }

          if (history.state.sort) {
            this.storeData.sort = history.state.sort;
          }

          if (history.state.currentPage) {
            this.storeData.currentPage = history.state.currentPage;
          }
        }
      }

      _updateHistory(updatePath = false, clear = false) {
        const utmValue = new URLSearchParams(window.location.search).get('utm_term');
        const landingPageTag = new URLSearchParams(window.location.search).get('tag');

        let state = {};
        state.filters = this.storeData.filters;
        state.sort = this.storeData.sort;
        state.currentPage = this.storeData.currentPage;

        if (updatePath) {
          const urlParams = new URLSearchParams();

          if (clear) {
            if (this.query) {
              urlParams.set('q', this.query);
            }

            if (utmValue) {
              urlParams.set('utm_term', utmValue);
            }

            if (landingPageTag) {
              urlParams.set('tag', landingPageTag);
            }
          } else {
            // Add search query if exists
            if (this.query) {
              urlParams.set('q', this.query);
            }
            
            // Add filter parameters
            if (this.storeData.filters) {
              const filterParams = new URLSearchParams(this.storeData.filters);
              for (const [key, value] of filterParams.entries()) {
                urlParams.set(key, value);
              }
            }
            
            // Add sort parameter
            if (this.storeData.sort) {
              const sortParams = new URLSearchParams(this.storeData.sort);
              for (const [key, value] of sortParams.entries()) {
                urlParams.set(key, value);
              }
            }
            
            // Add page parameter
            if (this.storeData.currentPage && this.storeData.currentPage !== 1) {
              urlParams.set('page', this.storeData.currentPage.toString());
            }

            if (utmValue) {
              urlParams.set('utm_term', utmValue);
            }

            if (landingPageTag) {
              urlParams.set('tag', landingPageTag);
            }
          }

          const queryString = urlParams.toString();
          const newPath = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
          history.pushState(state, '', newPath);
        } else {
          history.replaceState(state, '');
        }
      }

      _renderPagination(pagination, onPageClick) {
        const container = this.querySelector(this._selectors.pagination);
        if (!container) return;

        const { totalResults, begin, end, currentPage, totalPages, previousPage, nextPage } = pagination || {};
        if (!totalResults || totalPages <= 1) {
          container.innerHTML = '';
          return;
        }

        // Create page buttons
        const createPageButton = (label, page, isActive = false, isDisabled = false, ariaLabel) => {
          const disabledAttr = isDisabled ? 'aria-disabled="true"' : '';
          const activeClass = isActive ? ' is-active' : '';
          const aria = ariaLabel ? ` aria-label="${ariaLabel}"` : '';
          const dataAttr = isDisabled ? '' : ` data-page="${page}"`;
          return `<button class="btn btn--solid btn--small pagination__btn ${activeClass}"${dataAttr} ${disabledAttr}${aria}>${label}</button>`;
        };

        // Create prev and next buttons
        const createControllerButton = (label, page, isActive = false, isDisabled = false, ariaLabel) => {
          const disabledAttr = isDisabled ? 'aria-disabled="true" disabled' : '';
          const activeClass = isActive ? ' is-active' : '';
          const aria = ariaLabel ? ` aria-label="${ariaLabel}"` : '';
          const dataAttr = isDisabled ? '' : ` data-page="${page}"`;
          return `<button class="btn btn--solid btn--small pagination__btn pagination__btn--controller ${activeClass}"${dataAttr} ${disabledAttr}${aria}>${label}</button>`;
        };

        const caretLeft = `<span class="pagination__chevron pagination__chevron--left">
                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-linecap="square"/></svg>
                           </span>`

        const caretRight = `<span class="pagination__chevron pagination__chevron--right">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="square"/></svg>
                            </span>`

        // Show 5 pages at a time
        const pageButtons = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = startPage + maxVisible - 1;

        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
          const isActive = i === currentPage;
          pageButtons.push(createPageButton(i, i, isActive, false, `Go to page ${i}`));
        }

        // Create markup
        const prevDisabled = currentPage <= 1;
        const nextDisabled = currentPage >= totalPages;

        const paginationMarkup = `<div class="pagination__controls">
                                    ${createControllerButton(caretLeft, previousPage || (currentPage - 1), false, prevDisabled, 'Go to previous page')}
                                    <div class="pagination__pages">${pageButtons.join('')}</div>
                                    ${createControllerButton(caretRight, nextPage || (currentPage + 1), false, nextDisabled, 'Go to next page')}
                                  </div>`;

        container.innerHTML = paginationMarkup;

        // Init button click events
        container.querySelectorAll('[data-page]').forEach((btn) => {
          btn.addEventListener('click', (evt) => {
            const target = evt.currentTarget;
            const page = parseInt(target.getAttribute('data-page'), 10);
            if (!isNaN(page)) onPageClick(page);
          });
        });
      }

      _renderFilters(facets) {
        const formContainer = this.querySelector('[js-searchspring-filter-form]');

        if (!formContainer) return;

        if (!facets || facets.length === 0) {
          formContainer.innerHTML = '<p class="collection-drawer__empty">No filters available</p>';
          return;
        }

        // Check if accordions already exist - if so, don't re-render them
        const existingAccordions = formContainer.querySelectorAll('details[data-collapsible]');
        if (existingAccordions.length > 0) {
          this._updateFilterInputs(facets);
          return;
        }

        let filtersMarkup = '';

        // Sort facets alphabetically by field name
        const sortedFacets = [...facets].sort((a, b) => {
          return a.field.localeCompare(b.field);
        });

        // Create markup
        sortedFacets.forEach((facet, index) => {
          let facetValues= '';
          let filterCount = 0;

          facet.values.forEach((value, i) => {
            const valueId = `FilterSort-${facet.field}-${i}`;

            if (value.active) {
              filterCount += 1;
            }

            facetValues = `${facetValues}
                          <li class="filter-sort__value">
                            <div class="filter-value">
                              <input type="checkbox"
                                name="${facet.field}"
                                value="${value.type == 'range' ? `&filter.${facet.field}.low=${value.low}&filter.${facet.field}.high=${value.high}` : `&filter.${facet.field}=${value.value}`}"
                                id="${valueId}"
                                class="filter-value__input visually-hidden"
                                ${value.active ? 'checked' : ''}
                                ${value.count == 0 && value.active == false ? 'disabled' : ''}
                                data-value="${value.type == 'range' ? `${value.label}` : `${value.value}`}"
                                js-filter-input
                              >
                              <label for="${valueId}" class="filter-value__label ${value.count == 0 && value.active == false ? 'disabled' : ''}" data-tag="${value.label}" js-filter-label>
                                ${
                                  facet.label == 'Color' ? `<span class="filter-value__label-checkbox"><span class="filter-value__label-checkbox--checked" style="background-color: ${value.label};"></span></span>` : 
                                  facet.label == 'Size' ? `<span class="filter-value__label-swatch btn btn-solid">${value.label}</span>` : 
                                  `<span class="filter-value__label-checkbox"><span class="filter-value__label-checkbox--checked"></span></span><span>${value.label}</span>`
                                }
                              </label>
                            </div>
                          </li>`;
          });
          
          filtersMarkup = `${filtersMarkup}
                          <details class="filter-sort accordion" data-collapsible desktop="true" mobile="true" data-index="${index + 1}">
                            <summary class="filter-sort__label accordion__title" data-collapsible-trigger>
                              <span>
                                ${facet.label}
                              </span>
                              <div class="icon-wrapper">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret-down" viewBox="0 0 16 16">
                                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-linecap="square"/>
                                </svg>
                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret-up" viewBox="0 0 16 16">
                                <path d="M12 10L8 6L4 10" stroke="currentColor" stroke-linecap="square"/>
                                </svg>
                              </div>
                            </summary>
                            <div class="filter-sort__values-container accordion__body" data-collapsible-body>
                              <div class="accordion__content" data-collapsible-content>
                                <ul class="filter-sort__values collection-nav${ facet.label == 'Color' || facet.label == 'Size' ? ' filter-sort__values--flex' : '' }" role="list">${facetValues}</ul>   
                              </div>
                            </div>
                          </details>`;
        });

        formContainer.innerHTML = `<collapsible-elements>${filtersMarkup}</collapsible-elements>`;

        // Set filter change event listener
        this.filterInputs = this.querySelectorAll('[js-filter-input]');
        this.filterInputs.forEach(checkbox => {
          checkbox.addEventListener('change', this._handleFilterChange);
        });
      }

      _updateFilterInputs(facets) {
        const formContainer = this.querySelector('[js-searchspring-filter-form]');
        if (!formContainer) return;

        // Sort facets alphabetically by field name
        const sortedFacets = [...facets].sort((a, b) => {
          return a.field.localeCompare(b.field);
        });

        // Update existing filter inputs with new data
        sortedFacets.forEach((facet, index) => {
          const accordion = formContainer.querySelector(`details[data-index="${index + 1}"]`);
          if (!accordion) return;

          const valuesList = accordion.querySelector('.filter-sort__values');
          if (!valuesList) return;

          let facetValues = '';
          facet.values.forEach((value, i) => {
            const valueId = `FilterSort-${facet.field}-${i}`;

            facetValues = `${facetValues}
                          <li class="filter-sort__value">
                            <div class="filter-value">
                              <input type="checkbox"
                                name="${facet.field}"
                                value="${value.type == 'range' ? `&filter.${facet.field}.low=${value.low}&filter.${facet.field}.high=${value.high}` : `&filter.${facet.field}=${value.value}`}"
                                id="${valueId}"
                                class="filter-value__input visually-hidden"
                                ${value.active ? 'checked' : ''}
                                ${value.count == 0 && value.active == false ? 'disabled' : ''}
                                data-value="${value.type == 'range' ? `${value.label}` : `${value.value}`}"
                                js-filter-input
                              >
                              <label for="${valueId}" class="filter-value__label ${value.count == 0 && value.active == false ? 'disabled' : ''}" data-tag="${value.label}" js-filter-label>
                                ${
                                  facet.label == 'Color' ? `<span class="filter-value__label-checkbox"><span class="filter-value__label-checkbox--checked" style="background-color: ${value.label};"></span></span>` : 
                                  facet.label == 'Size' ? `<span class="filter-value__label-swatch btn btn-solid">${value.label}</span>` : 
                                  `<span class="filter-value__label-checkbox"><span class="filter-value__label-checkbox--checked"></span></span><span>${value.label}</span>`
                                }
                              </label>
                            </div>
                          </li>`;
          });

          valuesList.innerHTML = facetValues;
        });

        // Update filter change event listeners
        this.filterInputs = this.querySelectorAll('[js-filter-input]');
        this.filterInputs.forEach(checkbox => {
          checkbox.addEventListener('change', this._handleFilterChange);
        });
      }

      _renderSort(sort) {
        const sortContainer = this.querySelector('[js-sort-container]');
        let sortOptions = '';

        // Create markup
        if (!sort.options || !sortContainer) return;
        sort.options.forEach((option) => {
          sortOptions = `${sortOptions}<option value="&sort.${option.field}=${option.direction}" ${option.active == 1 ? 'selected="selected"' : ''}>${option.label}</option>`;
        });

        const sortMarkup = `<select name="searchspring-sort-select"  data-options='{ "allowHTML": false }' js-sort-trigger>
                              <option disabled selected>Sort</option>
                              ${sortOptions}
                            </select>`;

        sortContainer.innerHTML = sortMarkup;

        // Set sort change event listener
        this.sortSelect = this.querySelector(this._selectors.sortTrigger);
        this.sortSelect.addEventListener('change', this._handleSortChange);
      }

      _renderActiveFilters(filterSummary) {
        // Clear any pending update
        if (this.activeFiltersUpdateTimeout) {
          clearTimeout(this.activeFiltersUpdateTimeout);
        }
        // Debounce the update to prevent flickering
        this.activeFiltersUpdateTimeout = setTimeout(() => {
          this._updateActiveFilters(filterSummary);
        }, 50);
      }

      _updateActiveFilters(filterSummary) {
        const activeFilters = this.querySelector(this._selectors.activeFilters);
        const activeFiltersContainer = this.querySelector(this._selectors.activeFiltersContainer);

        if (!activeFilters) {
          return;
        }

        // Check if we have any active filters to show
        const hasActiveFilters = filterSummary && filterSummary.length > 0;

        if (!hasActiveFilters) {
          if (activeFiltersContainer) {
            activeFiltersContainer.classList.add('hidden');
          }
          activeFilters.innerHTML = '';
          this.hasRenderedActiveFilters = false;
          return;
        }

        // Only render if haven't already rendered or if content has changed
        const newMarkup = this._generateActiveFiltersMarkup(filterSummary);
        const currentMarkup = activeFilters.innerHTML;
        
        if (!this.hasRenderedActiveFilters || currentMarkup !== newMarkup) {
          activeFilters.innerHTML = newMarkup;
          this.hasRenderedActiveFilters = true;
          
          // Add event listeners for remove buttons
          activeFilters.querySelectorAll(this._selectors.removeActiveFilter).forEach((button) => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              this._removeActiveFilter(button.dataset.filterField, button.dataset.filterValue);
            });
          });
        }

        if (activeFiltersContainer) {
          activeFiltersContainer.classList.remove('hidden');
        }
      }

      _generateActiveFiltersMarkup(filterSummary) {
        let activeFiltersMarkup = '';
        
        filterSummary.forEach((filter) => {
          if (filter.values && filter.values.length > 0) {
            filter.values.forEach((value) => {
              activeFiltersMarkup = `${activeFiltersMarkup}
                                    <button type="button" class="active-filter-remove btn btn--solid" data-filter-field="${filter.field}" data-filter-value="${value.value}" aria-label="Remove ${value.label} filter" js-remove-active-filter>
                                      <span class="active-filter-label">${value.label}</span>
                                      <div class="active-filter-icon">
                                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel path-stroke-width-adjustment" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7302 18.4923L5.50794 4.2701L4.27051 5.50754L18.4927 19.7298L19.7302 18.4923Z" fill="currentColor"/>
                                        <path d="M19.7305 5.50754L5.50781 19.7302L4.27051 18.4929L18.4932 4.27023L19.7305 5.50754Z" fill="currentColor"/>
                                        </svg>
                                      </div>
                                    </button>`;
            });
          }
        });

        return activeFiltersMarkup;
      }

      _removeActiveFilter(filterField, filterValue) {
        const formContainer = this.querySelector(this._selectors.filterForm);
        const filterInput = formContainer.querySelector(`input[name="${filterField}"][value*="${filterValue}"]`);
        
        if (filterInput) {
          filterInput.checked = false;
          filterInput.dispatchEvent(new Event('change'));
        }
      }

      _syncFormInputsWithFilters() {
        const formContainer = this.querySelector(this._selectors.filterForm);
        const filterString = this.storeData.filters;
        const filterPairs = filterString.split('&').filter(pair => pair.includes('='));
        
        filterPairs.forEach(pair => {
          const [key, value] = pair.split('=');
          if (key.startsWith('filter.')) {
            const filterField = key.replace('filter.', '');
            const filterValue = decodeURIComponent(value);
            const input = formContainer.querySelector(`input[name="${filterField}"][value*="${filterValue}"]`);
            input.checked = true;
          }
        });
      }

      _updateActiveFiltersFromForm() {
        const formContainer = this.querySelector(this._selectors.filterForm);
        if (!formContainer) {
          console.log('No form container found for updating active filters');
          return;
        }
        
        const checkedInputs = formContainer.querySelectorAll(`${this._selectors.filterInput}:checked`);
        console.log('Checked inputs found:', checkedInputs.length);
        
        if (checkedInputs.length === 0) {
          // No active filters, clear the display
          console.log('No active filters, clearing display');
          this._renderActiveFilters([]);
          return;
        }

        // Build active filters array from checked inputs
        const activeFilters = [];
        checkedInputs.forEach((input) => {
          const filterField = input.name;
          const filterValue = input.dataset.value || input.value;
          const filterLabel = input.dataset.value || input.value;
          
          console.log('Processing checked input:', filterField, filterValue, filterLabel);
          
          // Check if this filter field already exists in our array
          let existingFilter = activeFilters.find(f => f.field === filterField);
          if (!existingFilter) {
            existingFilter = { field: filterField, values: [] };
            activeFilters.push(existingFilter);
          }
          
          // Add this value to the filter
          existingFilter.values.push({
            value: filterValue,
            label: filterLabel,
            active: true
          });
        });

        console.log('Active filters to render:', activeFilters);
        // Render the active filters
        this._renderActiveFilters(activeFilters);
      }

      _updateResultsCount(totalResults) {
        const resultsCount = this.querySelector(this._selectors.resultsCount);
        if (resultsCount) {
          // Store the original text template if not already stored
          if (!resultsCount.dataset.textTemplate) {
            resultsCount.dataset.textTemplate = resultsCount.textContent;
          }
          // Replace the count in the text template
          const textTemplate = resultsCount.dataset.textTemplate;
          resultsCount.textContent = `${totalResults || 0} ${textTemplate}`;
        }
      }

      _updateFilterResultsCount(totalResults) {
        const resultsButton = this.querySelector(this._selectors.filterResults);
        if (resultsButton) {
          resultsButton.textContent = `View ${totalResults || 0} Results`;
        }
      }

      _toggleCollectionTouts(hide) {
        const collectionTouts = this.querySelectorAll(this._selectors.collectionTout);
        collectionTouts.forEach((tout) => {
          tout.style.display = hide ? 'none' : '';
        });
      }

      _measureTextWidth(text, element) {
        const tempElement = document.createElement('span');
        tempElement.style.visibility = 'hidden';
        tempElement.style.position = 'absolute';
        tempElement.style.fontSize = window.getComputedStyle(element).fontSize;
        tempElement.style.fontFamily = window.getComputedStyle(element).fontFamily;
        tempElement.style.fontWeight = window.getComputedStyle(element).fontWeight;
        tempElement.textContent = text;
        
        document.body.appendChild(tempElement);
        const textWidth = tempElement.offsetWidth;
        document.body.removeChild(tempElement);
        
        return textWidth;
      }

      _adjustSortSelectWidth() {
        const sortSelect = this.querySelector(this._selectors.sortTrigger);
        if (sortSelect && sortSelect.selectedIndex > 0) {
          const selectedText = sortSelect.options[sortSelect.selectedIndex].text;
          const textWidth = this._measureTextWidth(selectedText, sortSelect);
          const newWidth = Math.max(textWidth + this.CONFIG.SELECT_WIDTH_PADDING, this.CONFIG.SELECT_MIN_WIDTH);
          sortSelect.style.width = `${newWidth}px`;
        }
      }

      _handleFilterChange = async (evt) => {
        evt.preventDefault();
        
        // Reset active filters render for next filter operation
        this.hasRenderedActiveFilters = false;
        
        const formContainer = this.querySelector(this._selectors.filterForm);
        const checkedInputs = formContainer.querySelectorAll(`${this._selectors.filterInput}:checked`);
        let activeValues = '';
        checkedInputs.forEach((input) => {
          activeValues = `${activeValues}${input.value}`;
        });
        
        // Capture current sort state before re-render
        const currentSortSelect = this.querySelector(this._selectors.sortTrigger);
        let currentSortValue = '';
        let currentSortText = '';
        if (currentSortSelect) {
          currentSortValue = currentSortSelect.value;
          currentSortText = currentSortSelect.options[currentSortSelect.selectedIndex].text;
        }
        
        // Update data
        this.storeData.filters = activeValues;
        this.storeData.currentPage = 1;
        
        // Update search results
        await this._updateSearchResults(false);
        
        // Hide/show collection touts based on filter state
        this._toggleCollectionTouts(activeValues.length > 0);
        
        // Update active filters display based on current filter state
        setTimeout(() => {
          this._updateActiveFiltersFromForm();
        }, 0);
        
        // Wait for DOM to update, then restore sort select state
        if (currentSortValue && currentSortText) {
          setTimeout(() => {
            const newSortSelect = this.querySelector(this._selectors.sortTrigger);
            if (newSortSelect) {
              newSortSelect.value = currentSortValue;
              const textWidth = this._measureTextWidth(currentSortText, newSortSelect);
              const newWidth = Math.max(textWidth + this.CONFIG.SELECT_WIDTH_PADDING, this.CONFIG.SELECT_MIN_WIDTH);
              newSortSelect.style.width = `${newWidth}px`;
            }
          }, 0);
        }
      }

      _clearFilterSort = async () => {
        // Clear all data
        this.storeData.filters = '';
        this.storeData.sort = '';
        this.storeData.currentPage = 1;
        
        // Remove all active filter elements immediately
        const activeFilters = this.querySelector(this._selectors.activeFilters);
        const activeFiltersContainer = this.querySelector(this._selectors.activeFiltersContainer);
        if (activeFilters) {
          activeFilters.innerHTML = '';
        }
        if (activeFiltersContainer) {
          activeFiltersContainer.classList.add('hidden');
        }
        
        // Update search results with clear history
        await this._updateSearchResults(true);
        
        // Show collection touts when filters are cleared
        this._toggleCollectionTouts(false);
        
        // Reset sort select to default "Sort" option
        setTimeout(() => {
          const sortSelect = this.querySelector(this._selectors.sortTrigger);
          if (sortSelect) {
            sortSelect.selectedIndex = 0;
            sortSelect.style.width = '';
          }
        }, 0);
      }

      _handleSortChange = async (evt) => {
        evt.preventDefault();
        const select = evt.target;
        const selectedValue = select.value;
        const selectedText = select.options[select.selectedIndex].text;
        
        // Update data
        this.storeData.sort = selectedValue;
        this.storeData.currentPage = 1;
        
        // Update search results
        await this._updateSearchResults(false);
        
        // Wait for DOM to update, then restore select state and adjust select width
        setTimeout(() => {
          const newSelect = this.querySelector(this._selectors.sortTrigger);
          if (newSelect) {
            newSelect.value = selectedValue;
            const textWidth = this._measureTextWidth(selectedText, newSelect);
            const newWidth = Math.max(textWidth + this.CONFIG.SELECT_WIDTH_PADDING, this.CONFIG.SELECT_MIN_WIDTH);
            newSelect.style.width = `${newWidth}px`;
          }
        }, 0);
      }

      async _updateSearchResults(clearHistory = false) {
        // Update history and URL
        this._updateHistory(true, clearHistory);
        // Fetch new results
        const res = await this._fetchResults(this.query, 1);
        // Trigger a custom event that Vue can listen to
        this.dispatchEvent(new CustomEvent('searchResultsUpdated', {
          detail: {
            results: res,
            products: res.results || [],
            pagination: res.pagination || {},
            facets: res.facets || [],
            currentPage: 1
          }
        }));
        // Scroll to top
        window.scrollTo(0, 0);
      }
      
      async _fetchResults(query, currentPage) {
        console.log('fetchResults', query, currentPage)
        let filterParams = '';
        if (this.storeData.filters) {
          filterParams = this.storeData.filters;
        }
        
        let sortParams = '';
        if (this.storeData.sort) {
          sortParams = this.storeData.sort;
        }

        const cartProducts = encodeURIComponent(window.theme.getCookie('ssCartProducts'));
        const preflight = await fetch(`https://${this.siteId}.a.searchspring.io/api/personalization/preflightCache?siteId=${this.siteId}&userId=${this.userId}${this.shopperId ? `&shopper=${this.shopperId}` : ''}${cartProducts ? `&cart=${cartProducts}` : ''}${this.viewedProducts ? `&lastViewed=${this.viewedProducts}` : ''}`, {method: 'POST'})
          .then(res => console.log(res))
          .catch(err => console.error(err));

        const merchSegment = new URLSearchParams(window.location.search).get('utm_term');
        const landingPageTag = new URLSearchParams(window.location.search).get('tag');
        const fetchUrl = `https://${this.siteId}.a.searchspring.io/api/search/search.json?siteId=${this.siteId}&resultsFormat=json${landingPageTag ? `&landing-page=${landingPageTag}` : this.sectionType == 'search' ? `&q=${query}`: `&bgfilter.collection_handle=${this.collectionHandle}`}&bgfilter.ss_is_published=1&resultsPerPage=${this.productLimit}&page=${currentPage}&ajaxCatalog=Snap&resultsFormat=native&domain=${this.domain}&userId=${this.userId}&sessionId=${this.sessionId}&pageLoadId=${this.pageLoadId}${this.shopperId ? `&shopper=${this.shopperId}` : ''}${cartProducts ? `&cart=${cartProducts}` : ''}${this.viewedProducts ? `&lastViewed=${this.viewedProducts}` : ''}${filterParams}${sortParams}${merchSegment ? `&tag=merch.segment%2F${merchSegment}` : ''}`;
        const options = {method: 'GET', headers: {accept: 'application/json'}};
        const res = await fetch(fetchUrl, options)
          .then((res) => res.json());

        if (res.merchandising.redirect !== '') {
          window.location.href = res.merchandising.redirect;
          return false;
        }

        return res;
      }

      _clearCachedModals() {
        // Remove all cached quick-add modals from the body
        document.querySelectorAll('[data-quick-add-modal][data-added-to-body]').forEach((modal) => {
          modal.remove();
        });
      }
    }

    if (!customElements.get('searchspring-results')) {
      customElements.define('searchspring-results', SearchspringResults);
    }

    //  Product Card

    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this._selectors = {
          imageContainer: '[js-product-card-image-container]',
          featuredImage: '[js-product-card-featured-image]',
          hoverImage: '[js-product-card-hover-image]',
          relatedColors: '[js-related-colors]',
          swatch: '[js-product-card-swatch]',
          productLink: '[js-product-card-link]',
          price: '[js-product-card-price]',
          badgeHolder: '[js-product-card-badge-holder]',
          quickAddToCart: '[js-quick-add-to-cart]',
          optionSelector: '[js-product-option-selector]',
        }
      }

      connectedCallback() {
        this.optionSelector = this.querySelector(this._selectors.optionSelector);
        this.quickAddToCart = this.querySelector(this._selectors.quickAddToCart);
        this.imageContainer = this.querySelector(this._selectors.imageContainer);
        this.featuredImage = this.querySelector(this._selectors.featuredImage);
        this.hoverImage = this.querySelector(this._selectors.hoverImage);

        this._initRelatedColors();

        if (this.optionSelector) {
          this.optionSelector.addEventListener('change', this._enableAddToCart);
        }
        if (this.quickAddToCart) {
          this.quickAddToCart.addEventListener('click', this._addToCart);
        }
      }

      async _initRelatedColors() {
        this.relatedColorsContainer = this.querySelector(this._selectors.relatedColors);
        if (!this.relatedColorsContainer) {
          return;
        }
    
        const currentProductHandle = this.relatedColorsContainer.getAttribute('data-handle');
        const relatedColorsTag = this.relatedColorsContainer.getAttribute('data-tag');
        const targetURL = `/collections/product-grouping/${relatedColorsTag}/?view=json`;
        const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);

        let relatedColorsMarkup = '';
    
        if (relatedColorsJSON.length == 0) {
          return;
        }

        const swatchCount = relatedColorsJSON.length;
        const desktopSwatchLimit = 8;
        relatedColorsMarkup = '<div class="product-card__swatches-wrapper">';
        
        relatedColorsJSON.slice(0, desktopSwatchLimit).forEach((product, index) => {
          
          const isActive = product.productHandle === currentProductHandle;
          const isMobileHidden = index > 3 ? 'mobile-hidden' : '';
          
          relatedColorsMarkup += `
          <button type="button" class="product-card__swatch ${isMobileHidden}" data-active="${isActive}" js-product-card-swatch>
            <img src="${product.swatch_image}" alt="${product.swatch_color}" width="24" height="24">
          </button>`;
        })
        relatedColorsMarkup += '</div>';
        
        if (swatchCount > 1) {
          // Add color count display logic
          relatedColorsMarkup += `<div class="product-card__swatches-count product-card__swatches-count--total">${swatchCount} Colors</div>`;
          if (swatchCount > desktopSwatchLimit) {
            relatedColorsMarkup += `<div class="product-card__swatches-count product-card__swatches-count--desktop">+${swatchCount - desktopSwatchLimit} Colors</div>`;
          }
          if (swatchCount > 4) {
            relatedColorsMarkup += `<div class="product-card__swatches-count product-card__swatches-count--mobile">+${swatchCount - 4} Colors</div>`;
          }
      
          this.relatedColorsContainer.innerHTML = relatedColorsMarkup;
          this.relatedColorsContainer.classList.remove('hidden');
        }

        const swatches = this.querySelectorAll(this._selectors.swatch);

        swatches.forEach((swatch, index) => {
          swatch.dataset.json = JSON.stringify(relatedColorsJSON[index]);
        });

        this._handleSwatches();
      }

      _getRelatedColorJSON(url) {
        return fetch(url)
          .then(response => response.text())
          .then((text) => {
            const html = text;
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
            const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
            return parsedJSON;
          })
      }

      _handleSwatches = async () => {
        this.swatches = this.querySelectorAll(this._selectors.swatch);

        if (this.swatches.length < 1) {
          return;
        }

        this.productLinks = this.querySelectorAll(this._selectors.productLink);
        this.price = this.querySelector(this._selectors.price);
        this.badgeHolder = this.querySelector(this._selectors.badgeHolder);

        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._swatchTriggered(evt.currentTarget);
          });
        });
      }

      _setSwatchImageSource(img, url) {
        const picture = img.closest('picture');
        if (picture) {
          const source = picture.querySelector('source[type="image/webp"]');
          if (source) {
            const sep = url.includes('?') ? '&' : '?';
            source.setAttribute('srcset', `${url}${sep}format=webp`);
          }
        }
        img.removeAttribute('srcset');
        img.src = url;
      }

      _swatchTriggered = (swatch) => {
        if (swatch.dataset.active == 'true') {
          return;
        }

        const prevActiveSwatch = this.querySelector(`${this._selectors.swatch}[data-active="true"]`);
        if (prevActiveSwatch) prevActiveSwatch.dataset.active = 'false';
        swatch.dataset.active = 'true';

        const swatchData = JSON.parse(swatch.dataset.json);
        const newFeaturedImage = swatchData.featuredImage;
        const newHoverImages = (swatchData.hoverImages || '').split('|').filter(Boolean);

        // update images
        const featuredImg = this.featuredImage?.querySelector('img');
        if (featuredImg && newFeaturedImage) {
          this._setSwatchImageSource(featuredImg, newFeaturedImage);
        }
        if (this.hoverImage && newHoverImages.length > 0) {
          const hoverImgs = this.hoverImage.querySelectorAll('img');
          for (let i = Math.min(newHoverImages.length, hoverImgs.length) - 1; i >= 0; i--) {
            if (hoverImgs[i] && newHoverImages[i]) {
              this._setSwatchImageSource(hoverImgs[i], newHoverImages[i]);
            }
          }
        }

        // update product links
        if (this.productLinks && this.productLinks.length) {
          this.productLinks.forEach((link) => {
            link.href = swatchData.productUrl;
          });
        }

        // update price
        if (this.price) {
          const price = swatchData.price;
          const priceFiltered = swatchData.priceFiltered;
          const compareAtPrice = swatchData.compareAtPrice;
          const compareAtPriceFiltered = swatchData.compareAtPriceFiltered;
          let onSale = false;
          let priceMarkup = '';

          if (compareAtPrice && compareAtPrice > price) {
            onSale = true;
            priceMarkup = `<span class="product-card__price product-card__price--current">
                            ${priceFiltered}
                          </span>
                          <s class="product-card__price product-card__price--compare">
                            ${compareAtPriceFiltered}
                          </s>`;
          } else {
            priceMarkup = `<span class="product-card__price product-card__price--current">${priceFiltered}</span>`;
          }

          this.price.innerHTML = priceMarkup;
        }

        // update badge
        if (this.badgeHolder) {
          let badgeMarkup = '';
          if (swatchData.available == false) {
            badgeMarkup = '<div class="product-card__badge product-card__badge--sold-out">Sold Out</div>';
          } else if (swatchData.compareAtPrice && swatchData.price && swatchData.compareAtPrice > swatchData.price) {
            badgeMarkup = '<div class="product-card__badge product-card__badge--sale">Sale</div>';
          } else if (swatchData.customBadge) {
            badgeMarkup = `<div class="product-card__badge product-card__badge--custom">${swatchData.customBadge}</div>`;
          }
          this.badgeHolder.innerHTML = badgeMarkup;
        }

        // update quick add drawer handle
        const quickAddBtn = this.querySelector('[data-quick-add-btn]');
        if (quickAddBtn && swatchData.productHandle) {
          quickAddBtn.dataset.quickAddModalHandle = swatchData.productHandle;
        }
      }

      _cartAdd(data) {
        // Fetch post add to cart
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status != null) {
            alert(response.message);
            return;
          }
          document.querySelector('cart-items').getCart();
          this.optionSelector.value = '';
          this.quickAddToCart.setAttribute('disabled', 'disabled');
        })
        .catch((e) => {
          console.log(e);
        })
      }

      _addToCart = (evt) => {
        evt.preventDefault();
        const data = {
          items: [{ id: this.optionSelector.value, quantity: 1 }]
        };
        this._cartAdd(data);
      }

      _enableAddToCart = (evt) => {
        evt.preventDefault();
        const value = evt.currentTarget.value;
        if (value != '') {
          this.quickAddToCart.removeAttribute('disabled');
        }
      }
    }

    if (!customElements.get('product-card')) {
      customElements.define('product-card', ProductCard);
    }

    //  Product Card Alt

    class ProductCardAlt extends HTMLElement {
      constructor() {
        super();

        this._selectors = {
          imageSwapTrigger: '[js-preview-image-trigger]',
          secondaryImage: '[js-product-card-secondary-image]',
        }
      }

      connectedCallback() {
        this.imageSwapTrigger = this.querySelector(this._selectors.imageSwapTrigger);
        this.secondaryImages = this.querySelectorAll(this._selectors.secondaryImage);

        if (this.imageSwapTrigger) {
          this.imageSwapTrigger.addEventListener('click', this._handleImageSwap.bind(this));
        }
      }

      _handleImageSwap() {
        this.secondaryImages.forEach((secondaryImage) => {
          secondaryImage.classList.toggle('product-card__image--visible');
        });
      }
    }
    
    if (!customElements.get('product-card-alt')) {
      customElements.define('product-card-alt', ProductCardAlt);
    }

    //  Searchspring Recommendations

    class SearchspringRecommendations extends HTMLElement {
      constructor() {
        super();

        this._selectors = {
          productCard: 'product-card'
        }
      }

      connectedCallback() {
        this.siteId = 'hlq244';
        this.userId = theme.ssCookies.ssUserId;
        this.sessionId = theme.ssCookies.ssSessionIdNamespace;
        this.pageLoadId = theme.ssCookies.ssPageLoadId;
        this.shopperId = theme.ssCookies.ssShopperId;
        this.cartProducts = encodeURIComponent(this.dataset.cart || theme.ssCookies.ssCartProducts);
        this.viewedProducts = encodeURIComponent(theme.ssCookies.ssViewedProducts);
        this.sectionType = this.dataset.sectionType;
        this.productLimit = this.dataset.productLimit;
        this.profileTag = this.dataset.tag;
        this.productSku = this.dataset.sku;

        this.impressionObserver = null;

        this._createVueApp();
      }

      _createVueApp() {
        const { createApp, onBeforeMount, onMounted, ref, watch, nextTick, toRaw } = Vue;

        createApp({
          delimiters: ["${", "}"],
          setup: () => {
            // Core state
            const results = ref({});
            const loading = ref(false);
            const products = ref([]);
            const rootRoute = window.Shopify.routes.root;
            const sectionId = this.dataset.sectionId;
            const imagesLimit = this.dataset.productImagesLimit;

            // Setup
            onBeforeMount(async () => {
              loading.value = true;

              const res = await this._fetchResults();
              const prom = await this._fetchPromises(res);
              
              results.value = res;
              products.value = res[0].results || [];
              loading.value = false;
              //console.log('rec res', res, products.value)
              // Track render event for beacon tracking
              if (res && res[0] && res[0].results) {
                this._trackRenderEvent(res[0].results);
              }
            });

            watch(results, async (resultsVal) => {
              if (!resultsVal || !resultsVal.length) return;
              await nextTick();
              this.querySelectorAll(this._selectors.productCard).forEach((productCard) => {
                productCard._handleSwatches();
              });
              // Init silder component
              if (this.querySelector('slider-component')) {
                this.querySelector('slider-component').connectedCallback();
              }
              // Init hover images
              this.querySelectorAll('hover-images').forEach((element, index) => {
                element.initBasedOnDevice();
              })
              // Add click tracking to product links
              this._initClickTracking(toRaw(resultsVal)[0].results);
              // Add impression tracking
              this._initImpressionTracking(toRaw(resultsVal)[0].results);
            });

            onMounted(() => {
            });

            // Utils
            const formatPrice = (price) => {          
              return window.theme.formatMoney(price, theme.moneyFormat);
            };

            const handleizeString = (str) => {
              return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
            }

            const swatches = (product) => {
              const swatchTags = product.attributes.tags.filter((tag) => tag.startsWith('product-group-'));

              if (swatchTags.length == 0) return ''

              let swatchesMarkup = `<div class="product-card__swatches-container hidden"
                                      data-handle="${product.attributes.handle}"
                                      data-tag="${swatchTags[0]}"
                                      js-related-colors>
                                      <div class="product-card__swatches-wrapper">
                                      </div>
                                    </div>`;
              return swatchesMarkup
            }

            const variantSelector = (string, id) => {
              const variants = JSON.parse(string.join(',').replaceAll('&quot;', '"'));

              let optionsMarkup = '';
              for (let i = 0; i < variants.length; i++) {
                if (variants[i].inventory_quantity > 0) {
                  optionsMarkup = `${optionsMarkup}
                                  <option value="${variants[i].id}">
                                    ${variants[i].option1}
                                  </option>`;
                } else {
                  optionsMarkup = `${optionsMarkup}
                                  <option value="${variants[i].id}" disabled>
                                    ${variants[i].option1} (Out of Stock)
                                  </option>`;
                }
              }

              let selectMarkup = `<label for="OptionSelector-${id}" class="sr-only">Size</label>
                                  <select id="OptionSelector-${id}" class="product-card__select" js-product-option-selector>
                                    <option value="" disabled selected>Size</option>
                                    ${ optionsMarkup }
                                  </select>`
              return selectMarkup
            }

            const intelliSuggestClickTracking = (e, d, s) => {
              const el = e.currentTarget;
              if (IntelliSuggest && typeof IntelliSuggest.clickItem === 'function') {
                try {
                  IntelliSuggest.clickItem(el, {
                    siteId: this.siteId,
                    intellisuggestData: d,
                    intellisuggestSignature: s
                  });
                } catch (err) {
                  console.warn('[SS] clickItem error', err);
                }
              }
            }

            return {
              results,
              products,
              loading,
              rootRoute,
              sectionId,
              imagesLimit,
              formatPrice,
              swatches,
              variantSelector,
              intelliSuggestClickTracking,
            };
          },
        }).mount(this);
      }

      async _fetchResults() {
        const cartProducts = encodeURIComponent(window.theme.getCookie('ssCartProducts'));
        const preflight = await fetch(`https://${this.siteId}.a.searchspring.io/api/personalization/preflightCache?siteId=${this.siteId}&userId=${this.userId}${this.shopperId ? `&shopper=${this.shopperId}` : ''}${cartProducts ? `&cart=${cartProducts}` : ''}${this.viewedProducts ? `&lastViewed=${this.viewedProducts}` : ''}`, {method: 'POST'})
          .then(res => console.log(res))
          .catch(err => console.error(err));

        const fetchUrl = `https://${this.siteId}.a.searchspring.io/boost/${this.siteId}/recommend?tags=${this.profileTag}${this.productSku ? `&products=${this.productSku}` : ''}&limits=${this.productLimit}${this.shopperId ? `&shopper=${this.shopperId}` : ''}${this.cartProducts ? `&cart=${this.cartProducts}` : ''}${this.viewedProducts ? `&lastViewed=${this.viewedProducts}` : ''}`;
        const options = {method: 'GET', headers: {accept: 'application/json'}};
        
        try {
          const response = await fetch(fetchUrl, options);
          
          if (!response.ok) {
            console.error('Recommendations API error:', response.status, response.statusText);
            return null;
          }
          
          const res = await response.json();
          return res;
        } catch (error) {
          console.error('Error fetching recommendations:', error);
          return null;
        }
      }

      async _fetchPromises(response) {
        let arrayOfFetches = [];
        if (response && response[0] && response[0].results.length > 0) {
          const products = response[0].results;
          products.forEach((product, index) => {
            let newFetchUrl = `https://${this.siteId}.a.searchspring.io/api/search/search.json?siteId=${this.siteId}&resultsFormat=json&q=${product.mappings.core.uid}`;
            arrayOfFetches.push(newFetchUrl);
          });
        }

        let arrayOfProducts = [];
        const promises = [];
        for (const url of arrayOfFetches) {
          promises.push(
            fetch(url)
              .then(response => response.json())
              .then(response => {
                if (response.results && response.results[0]) {
                  arrayOfProducts.push(response.results[0]);
                }
              })
              .catch(err => {
                console.error('Product fetch error:', err);
              })
          );
        }
        await Promise.all(promises);
        return arrayOfProducts;
      }

      _sendBeaconEvents(events) {
        const beaconUrl = 'https://beacon.searchspring.io/beacon';
        
        fetch(beaconUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(events)
        })
        .then(response => {
          if (!response.ok) {
            console.error('Beacon API error:', response.status, response.statusText);
          }
          console.log('beacon res', response)
          return response.text();
        })
        .catch(err => {
          console.error('Beacon tracking error:', err);
        });
      }

      _trackRenderEvent(results) {
        if (!results || !results.length) return;

        const events = [];
        
        // Generate profile ID
        const profileId = uuidv4();

        let seed = [];
        if (this.productSku) {
          seed.push({ sku: this.productSku })
        } else if (this.dataset.cart) {
          this.dataset.cart.split(',').forEach((cartItem) => {
            seed.push({ sku: cartItem });
          });
        } else {
          seed.push("");
        }
        
        // Profile render event
        const profileEvent = {
          category: "searchspring.recommendations.user-interactions",
          context: {
            pageLoadId: this.pageLoadId,
            userId: this.userId,
            sessionId: this.sessionId,
            website: {
              trackingCode: this.siteId
            }
          },
          event: {
            context: {
              type: "product-recommendation",
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations"
            },
            profile: {
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations",
              seed
            }
          },
          id: profileId,
          type: "profile.render"
        };
        
        events.push(profileEvent);

        results.forEach((item) => {
          const productEvent = {
            category : "searchspring.recommendations.user-interactions",
            context : {
              pageLoadId : this.pageLoadId,
              userId : this.userId,
              sessionId : this.sessionId,
              website : {
                trackingCode : this.siteId
              }
            },
            event: {
              context : {
                type : "product-recommendation",
                tag : this.profileTag,
                placement : this.dataset.placement || "recommendations"
              },
              product : {
                id : item.id,
                mappings : item.mappings,
                seed
              }
            }, 
            id : uuidv4(),
            pid : profileId,
            type : "profile.product.render"
          }

          events.push(productEvent);
        });
        // Don't track impressions here - let the intersection observer handle it
        // This ensures we only track impressions when products actually come into view
        
        //console.log('render', events)
        this._sendBeaconEvents(events);
      }

      _trackProductClick(product) {
        if (!product || !product.mappings || !product.mappings.core) return;

        const events = [];
        const profileId = uuidv4();
        let seed = [];
        if (this.productSku) {
          seed.push({ sku: this.productSku })
        } else if (this.dataset.cartt) {
          this.dataset.cart.split(',').forEach((cartItem) => {
            seed.push({ sku: cartItem });
          });
        } else {
          seed.push("");
        }
        
        // Profile click event
        const profileEvent = {
          category: "searchspring.recommendations.user-interactions",
          context: {
            pageLoadId: this.pageLoadId,
            userId: this.userId,
            sessionId: this.sessionId,
            website: {
              trackingCode: this.siteId
            }
          },
          event: {
            context: {
              type: "product-recommendation",
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations"
            },
            profile: {
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations",
              seed
            }
          },
          id: profileId,
          type: "profile.click"
        };
        
        events.push(profileEvent);
        
        // Product click event
        const productEvent = {
          category: "searchspring.recommendations.user-interactions",
          context: {
            pageLoadId: this.pageLoadId,
            userId: this.userId,
            sessionId: this.sessionId,
            website: {
              trackingCode: this.siteId
            }
          },
          event: {
            context: {
              type: "product-recommendation",
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations"
            },
            product: {
              id: product.mappings.core.uid,
              mappings: {
                core: product.mappings.core,
              },
              seed
            }
          },
          id: uuidv4(),
          pid: profileId,
          type: "profile.product.click"
        };
        
        events.push(productEvent);
        //console.log('click', events)
        this._sendBeaconEvents(events);
      }

      _initClickTracking(products) {
        // Add click tracking to product links
        this.querySelectorAll('[js-product-card-link]').forEach((link) => {
          const productTarget = products.find((item) => item.id == link.dataset.productId);
          if (productTarget && productTarget.mappings && productTarget.mappings.core) {
            // Remove any existing click listeners to avoid duplicates
            link.removeEventListener('click', this._handleProductClick);
            
            // Add new click listener with product data
            link.addEventListener('click', (e) => {
              this._handleProductClick(e, productTarget);
            });
          }
        });
      }

      _handleProductClick(event, product) {
        // Track click event
        this._trackProductClick(product);
      }

      _initImpressionTracking(products) {
        // Create intersection observer for impression tracking
        this.impressionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this._trackProductImpression(products);
              this.impressionObserver.disconnect();
            }
          });
        }, {
          threshold: 0.5,
          rootMargin: '0px 0px -10% 0px'
        });

        // observe the section
        this.impressionObserver.observe(this);
      }

      _trackProductImpression(products) {
        if (!products || !products.length) return;

        const events = [];
        const profileId = uuidv4();
        let seed = [];
        if (this.productSku) {
          seed.push({ sku: this.productSku })
        } else if (this.dataset.cart) {
          this.dataset.cart.split(',').forEach((cartItem) => {
            seed.push({ sku: cartItem });
          });
        } else {
          seed.push("");
        }
        
        // Profile impression event (for carousel interactions)
        const profileEvent = {
          category: "searchspring.recommendations.user-interactions",
          context: {
            pageLoadId: this.pageLoadId,
            userId: this.userId,
            sessionId: this.sessionId,
            website: {
              trackingCode: this.siteId
            }
          },
          event: {
            context: {
              type: "product-recommendation",
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations"
            },
            profile: {
              tag: this.profileTag,
              placement: this.dataset.placement || "recommendations",
              seed
            }
          },
          id: profileId,
          type: "profile.impression"
        };
        
        events.push(profileEvent);
        
        // Product impression event
        products.forEach((product) => {
          const productEvent = {
            category: "searchspring.recommendations.user-interactions",
            context: {
              pageLoadId: this.pageLoadId,
              userId: this.userId,
              sessionId: this.sessionId,
              website: {
                trackingCode: this.siteId
              }
            },
            event: {
              context: {
                type: "product-recommendation",
                tag: this.profileTag,
                placement: this.dataset.placement || "recommendations"
              },
              product: {
                id: product.id,
                mappings: {
                  core: product.mappings.core
                },
                seed
              }
            },
            id: uuidv4(),
            pid: profileId,
            type: "profile.product.impression"
          };
          
          events.push(productEvent);
        });
        
        //console.log('impression', events)
        this._sendBeaconEvents(events);
      }

      disconnectedCallback() {
        // Clean up intersection observer
        if (this.impressionObserver) {
          this.impressionObserver.disconnect();
          this.impressionObserver = null;
        }
      }
    }

    if (!customElements.get('searchspring-recommendations')) {
      customElements.define('searchspring-recommendations', SearchspringRecommendations);
    }
})();